<template>
  <Layout>
    <div>
      <!-- <h4>You have no kiosks registered</h4>
      <Empty style="max-height: 60vh; margin-top: 3rem;" />-->
      <!-- <Grid :column-defs="columnDefs" :grid-data="kiosks" :resize-headers="false" id-key="KioskName" /> -->
      <div class="toolbar row p-2">
        <!-- v-if="$resize && $mq.above(992)" -->

        <div class="col-md-2">
          <input
            v-model="filter"
            class="form-control form-control-sm"
            type="text"
            :placeholder="`${contentType.name} Search (All Columns)`"
          />
        </div>

        <div class="col-md-10">
          <b-button-group class="mr-2">
            <b-button
              variant="dark"
              size="sm"
              class="btn-refresh-sm"
              :disabled="!contentType.permissions.includes('add') || loading"
              @click="add"
              >Add</b-button
            >
            <b-button
              variant="dark"
              size="sm"
              class="btn-refresh-sm"
              :disabled="
                !contentType.permissions.includes('edit') ||
                  selectedGridItems.length !== 1 ||
                  loading
              "
              @click="buttonEdit"
              >Edit</b-button
            >
            <!-- <b-button variant="dark" size="sm" class="btn-refresh-sm"
              >Copy</b-button
            > -->
            <b-button
              variant="dark"
              size="sm"
              class="btn-refresh-sm"
              :disabled="
                !contentType.permissions.includes('delete') ||
                  selectedGridItems.length !== 1 ||
                  loading
              "
              @click="doDelete"
              >Delete</b-button
            >
          </b-button-group>

          <button
            class="btn btn-sm btn-success btn-refresh mr-2"
            v-if="contentType.permissions.includes('saveOrder')"
            :disabled="
              !contentType.permissions.includes('saveOrder') || loading
            "
            @click="saveOrder"
            >Save Order</button
          >

          <button
            class="btn btn-sm btn-dark btn-refresh mr-2"
            :disabled="loading"
            @click="getData"
            >{{ loading ? 'Refreshing...' : 'Refresh' }}</button
          >

          <b-dropdown
            v-if="$resize && $mq.above(992)"
            text="Export"
            variant="dark"
            size="sm"
            class
          >
            <b-dropdown-item :disabled="isLoading" @click="csvExport">
              <b-icon icon="cloud-download" class="mr-1"></b-icon>Download CSV
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="col-md-3 text-right">
          <!-- <button
              class="btn btn-sm btn-dark ml-1"
              :disabled="loading || !selectedFlightId"
              @click="
                sidePanelModel.visible = !sidePanelModel.visible
                sidePanelModel.activeComponent = 'Fls'
              "
            >
              <b-icon v-if="!sidePanelModel.visible" icon="arrow-left"></b-icon>
              <b-icon v-if="sidePanelModel.visible" icon="arrow-right"></b-icon>
            </button> -->
        </div>
      </div>
      <div style="height: 100%">
        <div style="height: 100%; box-sizing: border-box;">
          <!-- <Timeline /> -->
          <BasicGrid
            v-if="items && items.length"
            ref="grid"
            :col-def="columnDefs"
            :data="items"
            :loading="loading"
            :quick-filter="filter"
            :selected="selectedGridItems"
            :content-type="contentType"
            @onSelectionChanged="onSelectionChanged"
            @onCellDoubleClicked="onCellDoubleClicked"
          ></BasicGrid>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from 'axios'


import BasicGrid from '@components/BasicGrid.vue'

import Layout from '@layouts/main.vue'

// import Timeline from '@components/timeline.vue';

import NotificationMixin from '@mixins/notificationMixin.js'

export default {
  name: 'ListingContainer',

  components: { Layout, BasicGrid },
  mixins: [NotificationMixin],
  props: {
    contentType: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      filter: null,
    }
  },
  computed: {
    exportParams() {
      console.log('exportParams', this.contentType)
      return {
        fileName: `Kiosk-${this.contentType.name}.csv`,
        suppressQuotes: false,
        columnSeparator: ',',
      }
    },
    columnDefs() {
      return this.contentType.fields.map((element) => {
        return element
      })
    },
    items() {
      return this.$store.getters[`${this.contentType.name}/list`]
    },
    selectedGridItems() {
      return this.$store.getters[`${this.contentType.name}/selectedGridItems`]
    },
    loading() {
      return this.$store.getters[`${this.contentType.name}/loading`]
    },
  },
  watch: {
    data(data) {
      this.rowData = data
      if (this.selected.length) {
        this.setSelectedRow(this.selected[0].Id)
      }
    },
    loading(loading) {
      if (loading) {
        this.gridOptions.api.showLoadingOverlay()
      } else {
        this.gridOptions.api.hideOverlay()
      }
    },
  },
  async created() {
    await this.getData()

    if (this.contentType.dependencies) {
      // Get dependency data
      const depData = this.contentType.dependencies
      await depData.forEach(async (key) => {
        await this.$store.dispatch(`${key}/all`, {
          ouRequired: false,
        })
      })
    }
  },
  methods: {
    csvExport() {
      this.$refs.grid.onBtnExport(this.exportParams)
    },
    async getData() {
      await this.$store.dispatch(`${this.contentType.name}/all`)
    },
    edit(id) {
      this.$router.push(`/${this.contentType.name}/${id}/edit`)
    },
    buttonEdit() {
      const id = this.selectedGridItems[0][this.contentType.idKey]
      this.edit(id)
    },
    onCellDoubleClicked(e) {
      const id = e.data[this.contentType.idKey]
      this.edit(id)
    },

    add() {
      this.$router.push(`/${this.contentType.name}/new`)
    },

    async saveOrder() {
      const rowData = this.$refs.grid.getRows()
      const ids = rowData.map((row) => row.MenuAirlineId)
      axios
        .patch(
          `${this.$config.apiBaseUrl}kioskManage/menuairlines/order/${ids}`
        )
        .then(() => {
          this.getData()
          this.showNotification(
            'The menu button order has been successfully updated.',
            'success'
          )
        })
        .catch((error) => this.showNotification(error, 'error'))
    },

    async doDelete() {
      const id = this.selectedGridItems[0][this.contentType.idKey]
      try {
        const x = await this.$store.dispatch(
          `${this.contentType.name}/delete`,
          id
        )
        console.log('x', x)
        this.getData()
      } catch (error) {
        
        console.log('error --> ', error)
        this.showNotification(error, 'error')
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
    },
    onSelectionChanged(payload) {
      this.$store.dispatch(
        `${this.contentType.name}/setSelectedGridItems`,
        payload
      )
    },
  },
}
</script>

<style></style>
